import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetBasketQuantity } from '@/generated/basket';
import { Area, PageType } from '@/generated/data.schemas';
import { useGetLayout } from '@/generated/layout';
import { useGetTranslations } from '@/generated/translations';
import { portalRootId } from '@/helpers';
import { BasketSummary } from '../BasketSummary';
import styles from './QuickBasket.module.scss';

export interface QuickBasketProps {
	offset: { x: number; y: number };
}

export const QuickBasket: React.FunctionComponent<QuickBasketProps> = ({ offset }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: layout } = useGetLayout(segmentationId);
	const staticLinks = layout?.data.staticLinks;
	const { data: translations } = useGetTranslations(segmentationId);
	const { data: quantityResponse } = useGetBasketQuantity(segmentationId);

	const basketUrl = staticLinks?.find((link) => link.pageType === PageType.Basket)?.url || '';
	const basketRoute = {
		area: Area.StaticPages,
		pageType: PageType.Basket,
	};

	const totalQuantity = quantityResponse?.data;

	return ReactDOM.createPortal(
		<aside
			className={styles.wrapper}
			style={{ '--offset-x': `${offset.x}px`, '--offset-y': `${offset.y}px` } as React.CSSProperties}
		>
			<h2 className={styles.title}>
				{totalQuantity} {translations?.data.miniBasket.productsInCart}
			</h2>
			<BasketSummary />
			<Button to={basketUrl} state={basketRoute} className={styles.basketButton}>
				{translations?.data.miniBasket.goToBasket}
			</Button>
		</aside>,
		document.getElementById(portalRootId) || document.body,
	);
};
